<template>
  <div>
    <b-modal :id="`edit-user-${id}`" title="Editar Usuário" size="lg">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <div style="display: flex;">
              <p style="font-size: 12px;">
                Criado por:
                {{
                  user.createdBy
                    ? `${user.createdBy.name} ${user.createdAt}`
                    : '-'
                }}
                <br />
                Editado por:
                {{
                  user.updatedBy
                    ? `${user.updatedBy.name} ${user.updatedAt}`
                    : '-'
                }}
              </p>
            </div>

            <label for="modal-user-name">
              {{ $t('menu.settings.users.labels.nameUser') }}:
            </label>

            <input
              type="text"
              v-model="user.name"
              id="modal-user-name"
              class="form-control"
              :placeholder="`${$t('menu.settings.users.placeholderNameUser')}`"
              @keyup="removeInvalidClass('modal-user-name')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackName') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-email">
              {{ $t('menu.settings.users.labels.email') }}:
            </label>
            <input
              type="email"
              v-model="user.email"
              id="modal-user-email"
              class="form-control"
              :placeholder="`${$t('menu.settings.users.placeholderEmailUser')}`"
              @keyup="removeInvalidClass('modal-user-email')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackEmail') }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-phone">
              {{ $t('menu.settings.users.labels.phone') }}:
            </label>
            <input
              type="text"
              v-model="user.celPhone"
              id="modal-user-phone"
              class="form-control"
              :placeholder="`${$t('menu.settings.users.placeholderPhoneUser')}`"
              v-mask="'+## (##) #####-####'"
              @keyup="removeInvalidClass('modal-user-phone')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackPhone') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-position">
              {{ $t('menu.settings.users.labels.post') }}:
            </label>
            <input
              type="text"
              v-model="user.occupation"
              id="modal-user-position"
              class="form-control"
              :placeholder="`${$t('menu.settings.users.placeholderPostUser')}`"
              @keyup="removeInvalidClass('modal-user-position')"
            />
            <div class="invalid-feedback">
              {{ $t('menu.settings.users.invalidFeedbackPost') }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-profile">
              {{ $t('menu.settings.users.labels.profile') }}:
            </label>
            <input
              type="text"
              id="modal-user-profile"
              class="form-control"
              :value="profileType"
              :disabled="true"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="modal-user-company">
              {{ $t('menu.settings.users.labels.company') }}:
            </label>
            <select
              class="form-control"
              multiple
              id="modal-user-company"
              v-model="selectedCompanies"
            >
              <option
                v-for="(item, i) in companiesOptions"
                :value="item.value"
                :key="i"
              >
                {{ item.text }}
              </option>
            </select>
            <!--
            <input
              type="text"
              id="input-company"
              class="form-control"
              :value="user.companyId.name"
              :disabled="true"
            />
            -->
          </div>
        </div>
      </div>
      <div class="row ml-2">
        <!-- <b-form-checkbox
          class
          id="treatments-responsible-edit"
          v-model="user.treatmentsResponsible"
        ></b-form-checkbox>
        <label for="treatments-responsible-edit">
          {{ $t('menu.settings.users.labels.responsible') }}
        </label>-->
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="w-100">
          <button @click="edit" class="float-right btn btn-primary ml-2">
            {{ $t('menu.settings.users.buttonSave') }}
          </button>
          <button
            @click="cancel(cancelar())"
            class="float-right btn btn-outline-primary"
          >
            {{ $t('menu.settings.users.buttonCancel') }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { lightFormat } from 'date-fns';
import swal from 'sweetalert';
import { mapFields } from 'vuex-map-fields';

export default {
  props: ['id', 'myUser', 'page', 'filter'],

  data: () => ({
    user: {},
    userAuth: null,
    formattedPhone: null,
    profileType: '',
    options: [],
    selectedCompanies: [],
    companiesOptions: [],
    currentCompanyList: [],
  }),

  computed: {
    ...mapFields('master', ['companyUsers']),
    ...mapState('master', ['allCompanies']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.user = { ...this.myUser };
    this.options = [
      { value: 'master', text: this.$t('menu.settings.users.labels.master') },
      { value: 'analyst', text: this.$t('menu.settings.users.labels.analyst') },
      { value: 'admin', text: this.$t('menu.settings.users.labels.admin') },
      { value: 'profile', text: this.$t('menu.settings.users.labels.other') },
    ];

    this.profileType = this.$t('menu.settings.users.labels.none');
    if (this.user.profileId) {
      if (this.user.profileId.type === 'master') {
        this.profileType = this.$t('menu.settings.users.labels.master');
      } else if (this.user.profileId.type === 'admin') {
        this.profileType = this.$t('menu.settings.users.labels.admin');
      } else if (this.user.profileId.type === 'analyst') {
        this.profileType = this.$t('menu.settings.users.labels.analyst');
      }
    }
    for (let i = 1; i < this.allCompanies.length; i += 1) {
      this.companiesOptions.push(this.allCompanies[i]);
    }
    if (this.user.companyList && this.user.companyList.length > 1) {
      this.selectedCompanies = this.user.companyList;
      this.currentCompanyList = this.user.companyList;
    } else {
      this.selectedCompanies.push(this.user.companyId._id);
      this.currentCompanyList.push(this.user.companyId._id);
    }
  },

  mounted() {
    const dayCreated = lightFormat(new Date(this.user.createdAt), 'dd/MM/yyyy');
    const hourCreated = lightFormat(new Date(this.user.createdAt), 'HH:mm');

    const dayUpdated = lightFormat(new Date(this.user.updatedAt), 'dd/MM/yyyy');
    const hourUpdated = lightFormat(new Date(this.user.updatedAt), 'HH:mm');

    this.user.createdAt = `${dayCreated} ${hourCreated}`;
    this.user.updatedAt = `${dayUpdated} ${hourUpdated}`;
  },

  methods: {
    ...mapActions('settings', ['editUserInfo']),
    ...mapActions('master', ['getUsers', 'getUsersMaster']),

    splitCompanyList() {

      const newCompanyList = this.selectedCompanies.filter((company) => {
        return !this.currentCompanyList.includes(company);
      });

      const removedCompanyList = this.currentCompanyList.filter((company) => {
        return !this.selectedCompanies.includes(company);
      });

      return {
        newCompanyList,
        removedCompanyList,
      };

    },

    async updateTableMaster(page = 1) {
      await this.getUsersMaster({
        token: this.userAuth.token,
        page,
        limit: '5',
        filter: this.filter,
      });
    },

    async edit(event) {
      if (this.validateFields()) {
        await this.editUserInfo({
          token: this.userAuth.token,
          userId: this.myUser._id,
          data: {
            name: this.user.name,
            email: this.user.email,
            occupation: this.user.occupation,
            celPhone: this.user.celPhone,
            treatmentsResponsible: this.user.treatmentsResponsible,
            companyList: this.selectedCompanies,
            updatedBy: this.userAuth._id,
            newCompanyList: this.splitCompanyList().newCompanyList,
            removedCompanyList: this.splitCompanyList().removedCompanyList,
          },
        })
          .then(() => {
            this.updateTableMaster(this.page);

            swal({
              title: this.$t('menu.settings.users.messages.editOk.text'),
              text: `${this.$t(
                'menu.settings.users.messages.editOk.description1',
              )}
                ${this.user.name}
                ${this.$t('menu.settings.users.messages.editOk.description2')}`,
              icon: 'success',
            });
          })
          .catch(() => {
            swal({
              title: this.$t('menu.settings.users.messages.editError.title'),
              text: this.$t(
                'menu.settings.users.messages.editError.description',
              ),
              icon: 'warning',
            });
          });
      } else {
        event.preventDefault();
      }
    },

    validateFields() {
      if (!this.user.name) {
        document.getElementById('modal-user-name').classList.add('is-invalid');
        return false;
      } else if (!this.user.email) {
        document.getElementById('modal-user-email').classList.add('is-invalid');
        return false;
        // } else if (!this.user.celPhone) {
        //   document.getElementById('modal-user-phone').classList.add('is-invalid');
        //   return false;
      } else if (!this.user.occupation) {
        document
          .getElementById('modal-user-position')
          .classList.add('is-invalid');
        return false;
      } else if (this.selectedCompanies.length === 0) {
        document
          .getElementById('modal-user-company')
          .classList.add('is-invalid');
        return false;
      }

      // if (!this.formatNumber()) {
      //   return false;
      // }

      return true;
    },

    // formatNumber() {
    //   this.formattedPhone = '';
    //   for (let i = 0; i <= this.user.celPhone.length; i += 1) {
    //     if (
    //       parseInt(this.user.celPhone.charAt(i), 10) ||
    //       this.user.celPhone.charAt(i) === '0'
    //     ) {
    //       this.formattedPhone += this.user.celPhone.charAt(i);
    //     }
    //   }
    //   if (
    //     !parseInt(this.formattedPhone, 10) &&
    //     this.formattedPhone.length !== 13
    //   ) {
    //     document.getElementById('modal-user-phone').classList.add('is-invalid');
    //     return false;
    //   }
    //   return true;
    // },

    removeInvalidClass(id) {
      const element = document.getElementById(id);
      for (let i = 0; i <= element.classList.length; i += 1) {
        if (element.classList[i] === 'is-invalid') {
          element.classList.remove('is-invalid');
        }
      }
    },

    cancelar() {
      this.user = { ...this.myUser, treatmentsResponsible: this.myUser.account.treatmentsResponsible };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/organisms/master/modal-edit-user/index.vue